<template>
  <div class="trail">
    <LayInfo :userModel="userModel" @longDo="longDo" @shortDo="shortDo" :isCanEdite="isCanEdite">
    </LayInfo>
    <LayAnnotationList :annotationList="annotationList" @mouseOutInput="mouseOutInput" @addItem="addItem"
      @deleteDo="deleteDo" :isCanEdite="isCanEdite">
    </LayAnnotationList>
    <div class="status-box">
      <div class="status-time status-font">{{ statusModel.time }}</div>
      <div :class="showCancel ? 'cancel-status-start status-font' : 'status-start status-font'">{{ statusModel.start }}
      </div>
      <div class="status-line"></div>
      <div :class="showCancel ? 'cancel-status-finish status-font' : 'status-finish status-font'">{{ statusModel.finish }}
      </div>
      <div class="status-title" :style="{ backgroundColor: statusModel.bgColor }">
        {{ statusModel.status }}
      </div>
      <el-button v-show="showCancel" class="cancelBtn" @click="cancelTrialDo">Cancel</el-button>
    </div>
    <div class="input-box">
      <div class="topTitle">Input</div>
      <div class="input-line-box" v-for="item in inputsList" :key="item">
        <div class="line"></div>
        <div class="download-left">{{ item.name }}</div>
        <div class="download-url">
          <a :href="item.url" target="_blank">{{ item.url }}</a>
        </div>
        <div class="right-box">
          <div class="long" @click="inputLongDo(item)" :style="{
            color: longColor(item),
            backgroundColor: longBgColor(item),
          }">
            LongLived
          </div>
          <div class="short" @click="inputShortDo(item)" :style="{
            color: shortColor(item),
            backgroundColor: shortBgColor(item),
          }">
            ShortLived
          </div>
        </div>
      </div>
    </div>
    <div class="table-box">
      <el-table :data="dataList" style="width: 100%" stripe tooltip-effect="light" border :header-cell-style="{
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#383838',
        background: '#ECF2FE',
        borderColor: '#999999',
      }" 
      :cell-style="{
        background: '#FFFFFF',
        borderColor: '#999999',
        fontSize: '15px',
        fontWeight: '400',
        color: '#383838',
      }">
        <el-table-column prop="name" label="Runners" width="100" align="center">
        </el-table-column>
        <el-table-column prop="image" label="Image"> </el-table-column>
        <el-table-column label="Resource" align="center">
          <el-table-column prop="env" label="Env">
            <template #default="scope">
              <div class="table-env-box">
                <div class="table-env" v-if="scope.row?.envList?.length > 0">
                  <p v-for="env in scope.row.showEnvList" :key="env">{{ env }}</p>
                </div>
                <div class="table-env" v-else> / </div>
                <div class="img-box" v-if="showEnvFold(scope.row.envList)">
                  <div class="img-box-btn" @click="showEnvDo(scope.row)">
                    {{ isFold(scope.row.showEnvList) ? 'unfold' : 'fold' }}<img :src="isFold(scope.row.showEnvList) ? require('@/assets/unfold-icon.png') : require('@/assets/fold-icon.png') "/>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="spec" label="Spec" width="120">
          </el-table-column>
          <el-table-column prop="status" label="Status" width="110">
          </el-table-column>
          <el-table-column prop="createTime" label="CreateTime" width="110">
            <template #default="scope">
              <div class="table-time">
                <p class="time-ymd">{{ scope.row.ymd }}</p>
                <p class="time-hms">{{ scope.row.hms }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="durationTime" label="DurationTime" width="120">
          </el-table-column>
          <el-table-column prop="peakmemory" label="PeakMemory" width="115">
          </el-table-column>
          <el-table-column prop="timeout" label="Timeout" width="85">
          </el-table-column>
          <el-table-column prop="dind" label="Dind" width="60">
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="output-box" v-show="outPutAllList.length > 0">
      <div class="topTitle">Output</div>
      <div class="output-line-box" v-for="list in outPutsList" :key="list">
        <div class="line"></div>
        <div class="output-line" v-for="item in list" :key="item">
          <el-popover :width="210" trigger="hover" placement="top" popper-class="popover-box" :visible="item.isShow">
            <template #default>
              <div class="popover-content" @mouseenter="enterPopover(item)" @mouseleave="leavePopover(item)">
                <span class="popover-top-title">{{ popoverTopTitle }}</span>
                <div class="popover-footer">
                  <el-button class="popover-btn" size="small" type="primary" @click="showLog(item)">YES</el-button>
                </div>
              </div>
            </template>
            <template #reference>
              <div class="output" @click="downloadDo(item)" @mouseenter="mouseLineEnter(item)"
                @mouseleave="mouseLineLeave(item)">
                {{ item.name }}
              </div>
            </template>
          </el-popover>
        </div>
      </div>
      <div class="output-line-box" v-for="list in outPutTreeList" :key="list">
        <div class="line"></div>
        <div class="output-line" v-for="item in list" :key="item">
          <el-tree highlight-current class="tree" :data="item" :props="defaultProps" @node-click="handleNodeClick"
            @node-contextmenu="handleNodeContextMenu">
            <template #default="{ node }">
              <!-- :visible="treeShow(node)"  -->
              <el-popover :width="210" trigger="hover" placement="top" popper-class="popover-box" :visible="treeShow(node)">
                <template #default>
                  <div class="popover-content" @mouseenter="enterTreePopover(node)" @mouseleave="leaveTreePopover(node)">
                    <span class="popover-top-title">{{ msgTitle(node) }}</span>
                    <div class="popover-footer" v-show="showBtn">
                      <el-button class="popover-btn" size="small" type="primary"
                        @click="showTreeLog(node)">YES</el-button>
                    </div>
                  </div>
                </template>
                <template #reference>
                  <span class="custom-tree-node" @mouseover="mouseTreeEnter(node)" @mouseout="mouseTreeLeave(node)">
                    {{ node.label }}
                  </span>
                </template>
              </el-popover>
            </template>
          </el-tree>
        </div>
      </div>
    </div>

    <div class="input-box data-output-box" v-show="dataOutPutsList.length > 0">
      <div class="topTitle">Output</div>
      <div class="input-line-box" v-for="item in dataOutPutsList" :key="item">
        <div class="line"></div>
        <div class="download-left">{{ item.name }}</div>
        <div class="download-url download-url-width">
          <a :href="item.url" target="_blank">{{ item.url }}</a>
        </div>
      </div>
    </div>

    <div class="output-box" v-show="debugsAllList.length > 0">
      <div class="topTitle">Debug</div>
      <div class="output-line-box" v-for="list in debugsList" :key="list">
        <div class="line"></div>
        <div class="output-line" v-for="item in list" :key="item">
          <el-popover :width="210" trigger="hover" placement="top" popper-class="popover-box" :visible="item.isShow">
            <template #default>
              <div class="popover-content" @mouseenter="enterPopover(item)" @mouseleave="leavePopover(item)">
                <span class="popover-top-title">{{ popoverTopTitle }}</span>
                <div class="popover-footer">
                  <el-button class="popover-btn" size="small" type="primary" @click="showLog(item)">YES</el-button>
                </div>
              </div>
            </template>
            <template #reference>
              <div class="output" @click="downloadDo(item)" @mouseenter="mouseLineEnter(item)"
                @mouseleave="mouseLineLeave(item)">
                {{ item.name }}
              </div>
            </template>
          </el-popover>
        </div>
      </div>


      <div class="output-line-box" v-for="list in debugsTreeList" :key="list">
        <div class="line"></div>
        <!-- v-for="item in list" :key="item" -->
        <div class="output-line" v-for="item in list" :key="item">
          <el-tree highlight-current class="tree" :data="item" :props="defaultProps" @node-click="handleNodeClick"
            @node-contextmenu="handleNodeContextMenu">
            <template #default="{ node }">
              <el-popover :width="210" trigger="hover" placement="top" popper-class="popover-box"
                :visible="treeShow(node)">
                <template #default>
                  <div class="popover-content" @mouseenter="enterTreePopover(node)" @mouseleave="leaveTreePopover(node)">
                    <span class="popover-top-title">{{ msgTitle(node) }}</span>
                    <div class="popover-footer" v-show="showBtn">
                      <el-button class="popover-btn" size="small" type="primary"
                        @click="showTreeLog(node)">YES</el-button>
                    </div>
                  </div>
                </template>
                <template #reference>
                  <span class="custom-tree-node" @mouseenter="mouseTreeEnter(node)" @mouseleave="mouseTreeLeave(node)">
                    {{ node.label }}
                  </span>
                </template>
              </el-popover>
            </template>
          </el-tree>
        </div>
      </div>
    </div>
    <UniversalPopover :dialogVisible="popoverDialogVisible" :title="dialogTitle" @cancelDo="cancelDo"
      @comfirmDo="comfirmDo"></UniversalPopover>
    <UniversalPopover :dialogVisible="inputDialogModel.isVisible" :title="inputDialogModel.normalTitle" :bright-title="inputDialogModel.brightTitle" @cancelDo="cancelDo"
      @comfirmDo="inputComfirmDo"></UniversalPopover>
  </div>
</template>
<script>
import {
  getQueryStatus,
  getPageUserByUserId,
  getNewOSSUrl,
  updateAnnotation,
  markLongLive,
  cancelTrial
} from "@/request/api";

import {
  ResourceType,
  RunnerStatus,
} from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
import LayInfo from "@/components/LayInfo.vue";
import LayAnnotationList from "@/components/LayAnnotationList.vue";
import UniversalPopover from "@/components/UniversalPopover.vue";
import { downloadByUrl } from "@/utils/DownLoad";
import { formatTimeToHMS, formatTimeTo2HMS, getStrWidthBySpan } from "@/utils/common";
import moment from "moment";
let timer = null;
const NORMAL_ENV_COUNT = 3
export default {
  name: "trail",
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label",
      },
      selectNode: {},
      userModel: {
        name: "",
        time: "",
        type: 0,
      },
      statusModel: {
        time: "-",
        start: "",
        finish: "-",
        status: "",
        bgColor: "",
        currentState: null,
      },
      annotationList: [],
      inputsList: [],
      dataList: [],
      outPutAllList: [],
      outPutsList: [],
      outPutTreeList: [],

      debugsAllList: [],
      debugsTreeList: [],
      debugsList: [],

      dataOutPutsList: [],
      isTrial: true,
      resourceId: "",
      isCanEdite: false,
      showDialog: false,
      popoverTopTitle: "Do you want to see log ?",
      showCancel: false,
      popoverDialogVisible: false,
      dialogTitle: "Do you want to cancel trial ?",
      inputDialogModel: {
        normalTitle: "",
        brightTitle: "",
        isVisible: false,
        selectItem: {},
      }
    };
  },
  methods: {
    showEnvDo(row) {
      for (const model of this.dataList) {
        if (model?.envList?.length > NORMAL_ENV_COUNT) {
          if (model.name == row.name) {
            if (model?.showEnvList?.length <= NORMAL_ENV_COUNT) {
              model.showEnvList = model?.envList
            } else {
              model.showEnvList = model?.envList.slice(0, NORMAL_ENV_COUNT)
            }
          } else {
            model.showEnvList = model?.envList.slice(0, NORMAL_ENV_COUNT)
          }
        } else {
          model.showEnvList = model?.envList
        }
      }
    },
    cancelDo() {
      this.popoverDialogVisible = false;
      this.inputDialogModel.isVisible = false;
    },
    async comfirmDo() {
      this.cancelDo()
      await cancelTrial(this.resourceId)
      this.showCancel = false;
      this.statusModel.currentState = RunnerStatus.CANCELED
      this.updateStatus()
    },
    cancelTrialDo() {
      this.popoverDialogVisible = true;
    },
    updateStatus() {
      this.showCancel = false;
      const status = this.statusModel.currentState
      if (status == RunnerStatus.DONE) {
        this.statusModel.status = "Done";
        this.statusModel.bgColor = "#EEFCE8";
      } else if (status == RunnerStatus.ERROR) {
        this.statusModel.status = "Error";
        this.statusModel.bgColor = "#FFEBEB";
      } else if (status == RunnerStatus.RUNNING) {
        this.statusModel.status = "Running";
        this.statusModel.bgColor = "#DBECFF";
        this.showCancel = true;
      } else if (status == RunnerStatus.WAITING) {
        this.statusModel.status = "Waiting";
        this.statusModel.bgColor = "#FFF8E0";
        this.showCancel = true;
      } else if (status == RunnerStatus.TIMEOUT) {
        this.statusModel.status = "Timeout";
        this.statusModel.bgColor = "#E9E1FC";
      } else if (status == RunnerStatus.CANCELED) {
        this.statusModel.status = "Cancelled";
        this.statusModel.bgColor = "#E9E1FC";
      }
    },
    destoryTimer() {
      clearTimeout(timer)
      timer = null;
    },
    enterPopover(item) {
      // clearTimeout(timer);
      this.destoryTimer()
      item.isShow = true;
    },
    leavePopover(item) {
      // clearTimeout(timer);
      this.destoryTimer()
      item.isShow = false;
    },
    enterTreePopover(item) {
      // clearTimeout(timer);
      this.destoryTimer()
      item.data.isShow = true;
    },
    leaveTreePopover(item) {
      // clearTimeout(timer);
      this.destoryTimer()
      item.data.isShow = false;
    },
    showLog(item) {
      item.isShow = false;
      this.$router.push({
        name: "TrialLog",
        params: { bucket: item.ossfile.bucket, path: item.ossfile.key },
      });
    },
    showTreeLog(item) {
      item.data.isShow = false;
      this.$router.push({
        name: "TrialLog",
        params: {
          bucket: item.data.ossfile.bucket,
          path: item.data.ossfile.key,
        },
      });
    },

    mouseLineEnter(item) {
      if (this.statusModel.status == "Running") {
        item.isShow = true;
      } else {
        item.isShow = false;
      }
    },
    mouseLineLeave(item) {
      timer = setTimeout(() => {
        item.isShow = false;
      }, 200);
    },
    mouseTreeEnter(item) {
      item.data.isShow = false
      //&& this.statusModel.status == "Running"
      let wid = 0
      const winWidth = document.documentElement.clientWidth || document.body.clientWidth;
      const showWidth = winWidth - 850
      if (showWidth < 1200) {
        wid = 1200
      } else {
        wid = showWidth
      }
      const treeWidth = Math.round((wid - 10)/4 - 20*3 - (item.level - 2) * 32 - 50 - 13)
      const label = item.data.label
      const strWid = getStrWidthBySpan(label, 15)
      if (this.statusModel.currentState == RunnerStatus.RUNNING) {
        if (item.childNodes.length == 0) {
          item.data.isShow = true;
        }
      } else {
        if (item.childNodes.length == 0 && strWid > treeWidth) {
          item.data.isShow = true;
        }
      }
    },
    mouseTreeLeave(item) {
      item.data.isShow = false;
    },
    handleNodeContextMenu(item) {
      console.log("handleNodeContextMenu = ", item);
    },
    handleNodeClick(item) {
      console.log("handleNodeClick = ", item);
      if (item?.name) {
        const model = {
          name: item.name,
          ossfile: item.ossfile,
        };
        this.downloadDo(model);
        item.isShow = false
      }
    },
    deleteDo() {
      this.updateAnnotationData();
    },
    addItem() {
      console.log("addItem");
    },
    async updateAnnotationData() {
      let type = ResourceType.DATABUILDER;
      if (this.isTrial) {
        type = ResourceType.TRIAL;
      }
      await updateAnnotation({
        resourceId: this.resourceId,
        type: type,
        list: this.annotationList,
      });
    },
    mouseOutInput() {
      console.log("mouseOutInput");
      this.updateAnnotationData();
    },
    async longDo() {
      this.userModel.type = 1;
      let type = ResourceType.DATABUILDER;
      if (this.isTrial) {
        type = ResourceType.TRIAL;
      }
      this.updateLongLive({
        longLive: true,
        resourceId: this.resourceId,
        type: type,
      });
    },
    async shortDo() {
      this.userModel.type = 0;
      let type = ResourceType.DATABUILDER;
      if (this.isTrial) {
        type = ResourceType.TRIAL;
      }
      this.updateLongLive({
        longLive: false,
        resourceId: this.$route.params.id,
        type: type,
      });
    },
    async downloadDo(item) {
      console.log("item = ", item);
      this.showDialog = false;
      let fileName = item.name
      if (item?.name?.includes("/")) {
        const arr = item.name.split("/")
        if (arr?.length > 0) {
          fileName = arr.pop()
        }
      }
      const url = await getNewOSSUrl(
        item.ossfile.bucket,
        item.ossfile.key,
        fileName
      );
      item.isShow = false
      downloadByUrl(url, fileName);
    },
    async updateLongLive(item) {
      await markLongLive(item);
      this.$message.success("change successfully");
    },
    longColor(item) {
      return item.type == 1 ? "#ffffff" : "#A6A6A6";
    },
    longBgColor(item) {
      return item.type == 1 ? "#0052D9" : "#F5F5F5";
    },
    shortColor(item) {
      return item.type == 0 ? "#ffffff" : "#A6A6A6";
    },
    shortBgColor(item) {
      return item.type == 0 ? "#0052D9" : "#F5F5F5";
    },
    inputComfirmDo() {
      let longLive = false;
      if (this.inputDialogModel.selectItem.type == 0) {
        longLive = true
        this.inputDialogModel.selectItem.type = 1
      } else {
        longLive = false
        this.inputDialogModel.selectItem.type = 0
      }
      this.cancelDo()
      this.updateLongLive({
        longLive: longLive,
        resourceId: this.inputDialogModel.selectItem.dataId,
        type: ResourceType.DATA,
      });
    },
    inputLongDo(item) {
      if (!item?.isCanEdite) {
        return;
      }
      this.inputDialogModel.normalTitle =  "are you sure to change it to"
      this.inputDialogModel.brightTitle = "LongLived"
      if (item.type != 1) {
        this.inputDialogModel.isVisible = true;
        this.inputDialogModel.selectItem = item;
      }
    },
    inputShortDo(item) {
      if (!item?.isCanEdite) {
        return;
      }
      this.inputDialogModel.normalTitle = "are you sure to change it to"
      this.inputDialogModel.brightTitle = "ShortLived"
      if (item.type != 0) {
        this.inputDialogModel.selectItem = item;
        this.inputDialogModel.isVisible = true;
      }
    },
    getSortList(originList) {
      const debugList = [];
      const debugRow = Math.ceil(originList.length / 4);
      for (let i = 0; i < debugRow; i++) {
        debugList[i] = [];
        let modLast = originList.length % 4 === 0 ? 4 : originList.length % 4;
        let lastRow = i === debugRow - 1 ? modLast : 4;
        for (let j = 0; j < lastRow; j++) {
          debugList[i][j] = originList[4 * i + j];
        }
      }
      return debugList;
    },


    testFunc(orgChild, orgIndex, reduceIndex, list4) {
      const rdIndex = reduceIndex - 1
      for (const child of orgChild?.children) {
        if (rdIndex == 0) {
          const li = list4.filter(m => {
            return m.label == child.label
          })

          const chList = orgChild.filterList.filter(m => {
            return m.parentLableList[orgIndex] == child.label && m.parentLableList.length == orgIndex + 1
          })
          const chFilterList = orgChild.filterList.filter(m => {
            return m.parentLableList[orgIndex] == child.label
          })

          child.filterList = chFilterList
          let childrenList = chList
          for (const liM of li) {
            for (const child of liM.children) {
              childrenList.push(child)
            }
          }
          child.children = childrenList
        }
        this.testFunc(child, orgIndex, rdIndex, list4)
      }
    },
    getClassifyData(orignalDataList) {
      const masterOrignalDataList = [];
      let treeDataList = [];
      let normalDataList = [];
      const normalArr = [];
      let treeList = [];
      if (orignalDataList?.length > 0) {
        for (const outM of orignalDataList) {
          const name = outM.name;

          if (name.includes("/")) {
            masterOrignalDataList.push(outM);

          } else {
            outM.path = outM.name;
            outM.isShow = false;
            normalArr.push(outM);
          }
        }

        if (masterOrignalDataList.length > 0) {
          masterOrignalDataList.map((m) => {
            const list = m.name.split("/");

            m.list = list;
            m.rejectFirstList = list.slice(1, list.length)
            m.parentLableList = list.slice(0, list.length - 1)
            m.label = list[list.length - 1];
            m.parentLabel = list[list.length - 2];
            m.master = list[0];
            m.children = []
          });
          let masterList = [];
          masterOrignalDataList.forEach((m) => {
            masterList.push(m.master);
          });
          masterList = [...new Set(masterList)];
          for (const ma of masterList) {
            const orignalList = masterOrignalDataList.filter((model) => {
              return model.list[0] == ma
            });
            let maxCount = 0;
            for (const model of orignalList) {
              if (model.list.length >= maxCount) {
                maxCount = model.list.length;
              }
            }

            const parentLabelArr = []
            for (let count = 1; count <= maxCount; count++) {
              const li = []
              for (const orM of orignalList) {
                if (orM.list.length > count) {
                  li.push(orM.list[count - 1])
                }
              }
              if (li.length > 0) {
                parentLabelArr.push([...new Set(li)])
              }
            }

            const orignalFiltList = masterOrignalDataList.filter(m => {
              return m.master == ma
            })

            const masterList = orignalFiltList.filter(m => {
              return m.parentLableList[0] == ma && m.parentLableList.length == 1
            })

            const masterTreeList = []
            let masterChild = {
              label: ma,
              children: masterList,
              ossfile: "",
              path: "",
              isShow: false,
              filterList: orignalFiltList,
            };
            masterTreeList.push(masterChild)
            treeList.push(masterTreeList)
            if (parentLabelArr.length >= 2) {
              const titlesList = parentLabelArr[1]
              for (const title of titlesList) {
                const rcxList = orignalFiltList.filter(m => {
                  return m.parentLableList[1] == title
                })
                let rcxMaxCount = 0;
                for (const model of rcxList) {
                  if (model.parentLableList.length >= rcxMaxCount) {
                    rcxMaxCount = model.parentLableList.length;
                  }
                }
                let rcxItemsList = []
                for (let count = 0; count < rcxMaxCount; count++) {
                  let l = []
                  let l2 = []
                  for (const orM of rcxList) {
                    if (orM.list.length > count) {
                      if (orM.parentLableList[count]) {
                        l.push(orM.parentLableList[count])
                        // l2.push(orM.parentLableList[count])
                        if (orM.parentLableList[count + 1]) {
                          l2.push(orM.parentLableList[count + 1])
                        }
                      }
                    }
                  }
                  l = [...new Set(l)]
                  if (l.length > 0) {
                    rcxItemsList.push(l)
                  }
                }
                let rcxItemsList2 = []
                for (const rcxKey in rcxItemsList) {
                  const itemList = rcxItemsList[rcxKey]
                  let ll2 = []
                  for (const str1 of itemList) {
                    let ll1 = []
                    const ll = rcxList.filter(m1 => {
                      return m1.parentLableList[rcxKey] == str1
                    })
                    const secIndex = parseInt(rcxKey) + 1
                    for (const m1 of ll) {
                      const tt = m1.parentLableList[secIndex]
                      if (tt) {
                        ll1.push(tt)
                      }
                    }
                    if (ll1.length > 0) {
                      ll1 = [...new Set(ll1)]
                    }
                    const mm = {}
                    mm[`${str1}`] = ll1
                    ll2.push(mm)
                  }
                  rcxItemsList2.push(ll2)
                }

                let curChild = {}
                let curChList = []

                for (const index in rcxItemsList2) {
                  const rcxIndex = parseInt(index)
                  const itemList = rcxItemsList2[rcxIndex]
                  if (rcxIndex == 0) {
                    for (const itemMap of itemList) {
                      for (const key in itemMap) {
                        const children = []

                        const rcxFilterList = rcxList.filter(m => {
                          return m.parentLableList[rcxIndex] == key
                        })
                        const valueList = itemMap[key]
                        for (const v of valueList) {
                          const child = {
                            label: v,
                            children: [],
                            ossfile: "",
                            path: "",
                            isShow: false,
                          };
                          children.push(child)
                          masterChild.children.push(child)
                        }
                        const child = {
                          label: key,
                          children: children,
                          ossfile: "",
                          path: "",
                          isShow: false,
                          filterList: rcxFilterList
                        };
                        curChild = child
                      }

                    }
                  }
                  else {
                    curChList = []
                    for (const itemMap of itemList) {
                      for (const key in itemMap) {
                        const valueList = itemMap[key]
                        const children = []
                        for (const v of valueList) {
                          const child = {
                            label: v,
                            children: [],
                            ossfile: "",
                            path: "",
                            isShow: false,
                          };
                          children.push(child)
                        }
                        const child = {
                          label: key,
                          children: children,
                          ossfile: "",
                          path: "",
                          isShow: false,
                        };
                        curChList.push(child)
                      }
                    }
                    this.testFunc(curChild, rcxIndex, rcxIndex, curChList)
                  }
                }
              }
            }
          }
        }
        treeDataList = this.getSortList(treeList);
        normalDataList = this.getSortList(normalArr);
      }
      return [treeDataList, normalDataList];
    },
  },
  computed: {
    showEnvFold() {
      return (list => {
        return list?.length > NORMAL_ENV_COUNT 
      })
    },
    isFold() {
      return (list => {
        return list?.length <= NORMAL_ENV_COUNT 
      })
    },
    treeShow() {
      return function (item) {
        let isShow = false;
        if (item.childNodes.length == 0) {
          isShow = item.data.isShow;
        }
        return isShow;
      };
    },
    showBtn() {
      return this.statusModel.currentState == RunnerStatus.RUNNING
    },
    msgTitle() {
      return function (item) {
        return this.statusModel.currentState == RunnerStatus.RUNNING ? this.popoverTopTitle : item.label
      }
    }
  },
  components: {
    LayInfo,
    LayAnnotationList,
    UniversalPopover
  },
  async created() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    const param = this.$route.params;
    const id = param.id;
    this.resourceId = id;
    const path = this.$route.path;
    console.log(path);
    let type = ResourceType.TRIAL;
    let prefixTitle = "trial";
    if (path.includes("/data-builder")) {
      type = ResourceType.DATABUILDER;
      this.isTrial = false;
      prefixTitle = "data-builder";
    }
    let data
    try {
      data = await getQueryStatus(id, type);
    } catch (error) {
      loading.close()
    }
    console.log(data);
    let title = "";
    if (data.run?.annotationsMap) {
      const mapList = [...data.run.annotationsMap];
      title = this.$parent.$parent.getTitle(mapList);
    }
    document.title = `aqua.${prefixTitle}${title}`;

    const creationtime = data.run?.creationtime;
    const createTime = moment(
      (creationtime?.seconds + creationtime?.nanos / Math.pow(10, 9)) * 1000
    ).format("YYYY-MM-DD HH:mm:ss");
    const committer = data.run?.committer;
    const user = await getPageUserByUserId(committer);
    this.userModel.name = user.user?.nickname;
    this.userModel.time = createTime;
    this.userModel.type = data.run?.retention;

    for (const map of data.run?.annotationsMap) {
      const item = {
        keyWord: map[0],
        keyValue: map[1],
        isSelected: false,
        img: require("@/assets/data-normal-icon.png"),
      };
      this.annotationList.push(item);
    }

    const status = data.run?.status;
    this.statusModel.currentState = status
    this.updateStatus()
    this.statusModel.start = createTime;
    if (data.run?.finishtime && data.run?.finishtime.seconds > 0) {
      const durationTotalTime = data.run?.finishtime.seconds - creationtime.seconds;
      this.statusModel.time = formatTimeToHMS(durationTotalTime)
      const finishTime = moment(
        (data.run?.finishtime.seconds +
          data.run?.finishtime.nanos / Math.pow(10, 9)) *
        1000
      ).format("YYYY-MM-DD HH:mm:ss");
      this.statusModel.finish = finishTime;
    }

    const href = window.location.href.split("/benchmark").shift();
    console.log("href = ", href);
    for (const item of data.run?.inputsList) {
      const dd = await getQueryStatus(item.dataid, ResourceType.DATA);
      const isCanEdite = localStorage.getItem("userId") == dd.data?.committer;
      const input = {
        name: item.name,
        url: href + "/benchmark/data/" + item.dataid,
        type: dd.data?.retention,
        isCanEdite: isCanEdite,
        dataId: item.dataid,
      };
      this.inputsList.push(input);
    }

    for (const index in data.run?.runnersList) {
      const runner = data.run?.runnersList[index];
      const ind = parseInt(index) + 1;
      const requestmemory = runner.requestmemory
        ? `(${runner.requestmemory})`
        : "";
      let envStr = "";
      const envList = []
      if (runner.envMap?.length > 0) {
        for (const index in runner.envMap) {
          const map = runner.envMap[index];
          let str = "";
          if (runner.envMap.length - 1 == index) {
            str = map.join("=");
            envList.push(str);
          } else {
            envList.push(map.join("="));
            str = map.join("=") + "\n";
          }
          envStr += str;
        }
      } else {
        envStr = "/";
      }

      let durationTime = '/'
      if (runner.finishedtime && runner.startedtime.seconds) {
        durationTime = formatTimeTo2HMS(runner.finishedtime.seconds - runner.startedtime.seconds) 
      }
      const createTime = moment((runner.startedtime?.seconds + runner.startedtime?.nanos / Math.pow(10, 9)) * 1000).format("YYYY-MM-DD HH:mm:ss");
      let ymd = ""
      let hms = ""
      if (createTime.includes(" ")) {
        const times = createTime.split(" ")
        ymd = times.shift()
        hms = times.pop()
      } else {
        ymd = createTime
      }
      let showEnvList = []
      if (envList.length >= NORMAL_ENV_COUNT) {
        showEnvList = envList.slice(0, NORMAL_ENV_COUNT)
      } else {
        showEnvList = envList
      }
      const item = {
        name: ind,
        image: runner.image,
        spec:
          (runner.resource.spec ? runner.resource.spec : "/") + requestmemory,
        ip: runner.resource.ip ? runner.resource.ip : "/",
        env: envStr,
        peakmemory: runner.peakmemory ? runner.peakmemory : "/",
        createTime: createTime,
        ymd: ymd,
        hms: hms,
        durationTime: durationTime,
        timeout: `${runner.timeoutinhour}(H)`,
        dind: runner.dind,
        status: runner.status,
        envList: envList,
        showEnvList: showEnvList
      };
      this.dataList.push(item);
    }
    if (this.isTrial) {
      this.outPutAllList = data.run?.outputsList;
      if (this.outPutAllList?.length > 0) {
        const outPutArr = this.getClassifyData(this.outPutAllList);
        this.outPutTreeList = outPutArr[0];
        this.outPutsList = outPutArr[1];
      }
    } else {
      for (const item of data.run?.outputsList) {
        const put = {
          name: item.name,
          url: href + "/benchmark/data/" + item.dataid,
        };
        this.dataOutPutsList.push(put);
      }
    }

    if (data.run?.debugsList.length > 0) {
      this.debugsAllList = data.run?.debugsList;
      const debugsArr = this.getClassifyData(this.debugsAllList);
      this.debugsTreeList = debugsArr[0];
      this.debugsList = debugsArr[1];
    }
    this.isCanEdite = localStorage.getItem("userId") == committer;
    if (!this.isCanEdite) {
      this.showCancel = false;
    }
    loading.close()
  },
  beforeUnmount() {
    this.destoryTimer()
  },
};
</script>
<style>
.el-popover.popover-box {
  background: #fff;
  width: 100%;
  padding: 0px;
}

.popover-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  padding: 9px 8px;
}

.popover-top-title {
  color: #383838;
  font-size: 15px;
  text-align: center;
  margin-top: 2px;
}

.popover-footer {
  display: flex;
  margin-top: 10px;
  justify-content: space-around;
}

.popover-btn {
  min-height: 36px;
  height: 34px;
  padding: 10px 18px;
  font-size: 14px;
}
</style>
<style lang='less' scoped>
.trail {
  min-width: 1200px;
  width: calc(100% - 850px);
  margin: 0 auto;
  padding-bottom: 200px; //50px;
  position: relative;

  .status-box {
    font-weight: 18px;
    width: 100%;
    // color: #383838;
    height: 60px;
    display: flex;
    align-items: center;
    // justify-content: center;
    margin-top: 25px;
    padding: 10px 0px;
    background-color: #ffffff;

    .status-time {
      margin-left: 35px;
      width: 300px;
      background-color: #ecf2fe;
    }

    .status-start {
      width: calc((100% - 4 * 45px - 380px - 180px) / 2);
      margin-left: 45px;
      background-color: #f5f5f5;
    }

    .cancel-status-start {
      width: calc((100% - 4 * 45px - 380px - 280px) / 2);
      margin-left: 45px;
      background-color: #f5f5f5;
    }

    .status-line {
      // opacity: 1;
      height: 1.5px;
      width: 31px;
      background-color: #b9b9b9;
      margin-left: 10px;
    }

    //335 + 45
    .status-finish {
      width: calc((100% - 4 * 45px - 380px - 180px) / 2);
      margin-left: 10px;
      background-color: #f5f5f5;
    }

    .cancel-status-finish {
      width: calc((100% - 4 * 45px - 380px - 280px) / 2);
      margin-left: 10px;
      background-color: #f5f5f5;
    }

    .status-font {
      height: 100%;
      display: flex;
      align-items: center;
      text-align: left;
      padding-left: 8px;
      font-size: 14px;
      color: #383838;
      border-radius: 3px;
      font-weight: 400;
    }

    .status-title {
      width: 180px;
      height: 100%;
      background-color: #eefce8;
      margin-left: 45px;
      border-radius: 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #383838;
      font-weight: 700;
    }

    .cancelBtn {
      margin-left: 30px;
      color: #fff;
      font-size: 17px;
      height: 40px;
      width: 115px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #0052d9;
      border-radius: 20px;
    }
  }

  .input-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 25px;
    border-radius: 4px;
    background-color: #fff;

    .topTitle {
      color: #383838;
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      color: #383838;
      padding-left: 30px;
    }

    .input-line-box {
      display: flex;
      background-color: #fff;
      padding: 10px 30px 10px 0px;
      align-items: center;

      .line {
        width: 5px;
        height: 40px;
        background-color: #fbad15;
      }

      .download-left {
        margin-left: 30px;
        display: flex;
        width: 300px;
        background-color: #ecf2fe;
        height: 40px;
        align-items: center;
        padding-left: 10px;
        color: #383838;
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .download-url {
        background-color: #f5f5f5;
        height: 40px;
        display: flex;
        align-items: center;
        border-radius: 3px;
        font-size: 14px;
        width: calc(100% - 640px);
        margin-left: 50px;
        margin-right: 40px;
        padding: 0px 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        a {
          text-decoration: none;
          font-size: 14px;
          font-weight: 400;
          color: #0052d9;
        }
      }

      .download-url-width {
        width: calc(100% - 400px);
      }

      .right-box {
        display: flex;
        background-color: #f5f5f5;
        height: 36px;
        align-items: center;
        border-radius: 15px;

        .long {
          background-color: #0052d9;
          padding: 5px 15px;
          font-size: 16px;
          border-radius: 15px;
          color: #fff;
          cursor: pointer;
        }

        .short {
          background-color: #f5f5f5;
          padding: 5px 15px;
          font-size: 16px;
          border-radius: 15px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }

  .output-line-box {
    display: flex;
    flex-direction: row;
    // align-items: center; //测试
    padding-bottom: 20px;

    .line {
      width: 5px;
      height: 40px;
      background-color: #fbad15;
    }

    .output-line {
      display: flex;
      width: calc((100% - 10px) / 4);
      justify-content: space-between;
      padding: 0px 20px;

      .tree {
        width: calc((100% - 20px));
        // width: calc((100% - 15px));
        // padding-right: 5px;

        .custom-tree-node {
          cursor: pointer;
          height: 100%;
          width: 100%;
          background-color: #f3f3f3;
          display: inline-block;
          justify-content: center;
          align-content: center;
          text-align: left;
          padding-left: 8px;
          padding-top: 5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 15px;
        }
      }

      .output {
        width: calc(100% - 20px);
        height: 100%;
        background-color: #f5f5f5;
        display: flex;
        align-items: center;
        text-align: left;
        // padding-left: 10px;
        padding: 10px 5px 10px 10px;
        border-radius: 3px;
        font-size: 14px;
        color: #0052d9;
        font-weight: 400;
        cursor: pointer;
        word-break: break-all;
      }
    }
  }

  .output-box {
    background-color: #fff;
    margin-top: 20px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    width: 100%;

    .topTitle {
      color: #383838;
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      color: #383838;
      padding-left: 30px;
    }
  }

  .table-box {
    height: 100%;
    border: 1px solid #707070;
    margin-top: 20px;
  }

  .table {
    border-top: 2px solid #707070;
    border-left: 0px solid #707070;
    border-right: 0.5px solid #707070;
    border-bottom: 1.5px solid #707070;
    border-radius: 4px;
  }

  .table-env-box {
    display: flex;
    flex-direction: column;
    text-align: left;
    .table-env {
      display: flex;
      flex-direction: column;
      p {
        color: #383838;
        font-size: 14px;
        font-weight: 400;
        display: flex;
        text-align: left; 
        word-break: break-all;       
        // white-space: pre-wrap;
      }
    }
    .img-box {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .img-box-btn {
        font-size: 11px;
        color: #0052d9;
        display: flex;
        cursor: pointer;
        align-items: center;
        text-align: center;
        img {
          margin-left: 1px;
          width: 11px;
          object-fit: contain;
        }
      }
    }
  }
  .table-time {
    display: flex;
    flex-direction: column;
    .time-ymd {
      font-size: 15px;
      color: #383838;
    }
    .time-hms {
      font-size: 14px;
      color: #565656;
    }
  }
  .mytree {
    width: calc((100% - 10px) / 4 - 20px);
    padding: 0px 15px 0px 25px;

    .treeBg {
      width: 100%;
    }
  }
}


:deep(.el-table .cell) {
  padding: 0px 10px 0px 10px !important;
  white-space: pre-wrap !important;
}

:deep(.el-tree > .el-tree-node:after) {
  border-top: none;
}

:deep(.el-tree-node) {
  position: relative;
  padding-left: 16px;
}

//节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
:deep(.el-tree-node__expand-icon.is-leaf) {
  display: none;
}

:deep(.el-tree-node__children) {
  padding-left: 16px;
  margin-top: 10px;
}

:deep(.el-tree-node :last-child:before) {
  height: 40px;
}

:deep(.el-tree > .el-tree-node:before) {
  border-left: none;
}

:deep(.el-tree > .el-tree-node:after) {
  border-top: none;
}

:deep(.el-tree .el-tree-node) {
  margin-bottom: 10px;
}

:deep(.el-tree-node:after) {
  border-top: 1px dashed #1389bc;
  height: 20px;
  top: 12px;
  width: 18px;
}

:deep(.el-tree .el-tree-node__expand-icon.expanded) {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

:deep(.el-tree .el-icon-caret-right:before) {
  content: url(../assets/tree-open-icon.png);
  display: block;
  font-size: 16px;
  color: #1389bc;
  position: absolute;
  left: -20px;
  top: -8px;
}

:deep(.el-tree .el-tree-node__content) {
  padding-left: 5px !important;
  padding-top: 5px !important;
  height: 40px !important;
}

:deep(.el-tree .el-tree-node__label) {
  background-color: #f5f5f5 !important;
  width: 100% !important;
  text-align: left !important;
  height: 40px !important;
  line-height: 40px !important;
  padding-left: 8px !important;
}

:deep(.el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before) {
  content: url(../assets/tree-normal-icon.png);
  display: block;
  font-size: 16px;
  color: #1389bc;
  position: absolute;
  left: -20px;
  top: -8px;
}

:deep(.el-tree .el-tree-node__expand-icon.is-leaf::before) {
  background-image: url(../assets/tree-normal-icon.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 16px;
  height: 21px;
  font-size: 16px;
  background-size: 16px;
}

:deep(.el-tree-node__content > .el-tree-node__expand-icon) {
  padding: 0;
}

:deep(.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content > .el-tree-node__label) {
  color: #0050b3 !important;
}

:deep(.el-tree > .el-tree-node:after) {
  border-top: none;
}

:deep(.el-tree-node) {
  position: relative;
  padding-left: 16px;
}

//节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
:deep(.el-tree-node__expand-icon.is-leaf) {
  display: none;
}

:deep(.el-tree-node__children) {
  padding-left: 16px;
  margin-top: 10px;
}

:deep(.el-tree-node :last-child:before) {
  height: 40px;
}

:deep(.el-tree > .el-tree-node:before) {
  border-left: none;
}

:deep(.el-tree > .el-tree-node:after) {
  border-top: none;
}

:deep(.el-tree .el-tree-node) {
  margin-bottom: 10px;
}

:deep(.el-tree-node:after) {
  border-top: 1px dashed #1389bc;
  height: 20px;
  top: 12px;
  width: 18px;
}

:deep(.el-tree .el-tree-node__expand-icon.expanded) {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

:deep(.el-tree .el-icon-caret-right:before) {
  content: url(../assets/tree-open-icon.png);
  display: block;
  font-size: 16px;
  color: #1389bc;
  position: absolute;
  left: -20px;
  top: -8px;
}

:deep(.el-tree .el-tree-node__content) {
  padding-left: 5px !important;
  padding-top: 5px !important;
  height: 40px !important;
}

:deep(.el-tree .el-tree-node__label) {
  background-color: #f5f5f5 !important;
  width: 100% !important;
  text-align: left !important;
  height: 40px !important;
  line-height: 40px !important;
  padding-left: 8px !important;
}

:deep(.el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before) {
  content: url(../assets/tree-normal-icon.png);
  display: block;
  font-size: 16px;
  color: #1389bc;
  position: absolute;
  left: -20px;
  top: -8px;
}

:deep(.el-tree .el-tree-node__expand-icon.is-leaf::before) {
  background-image: url(../assets/tree-normal-icon.png) no-repeat 0 3px;
  content: "";
  display: block;
  width: 16px;
  height: 21px;
  font-size: 16px;
  background-size: 16px;
}

:deep(.el-tree-node__content > .el-tree-node__expand-icon) {
  padding: 0;
}

:deep(.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content > .el-tree-node__label) {
  color: #0050b3 !important;
}

:deep(.el-table th) {
  user-select: initial !important;
}
</style>